module.exports = __webpack_public_path__ + "img/f4ff7fd9366bcb7ee0a543b29a58dece.png";